import config from '../config';
import selectedEnvironment from '../env';
const API_BASE_URL = `${config[selectedEnvironment].API_URL}`;

const fetchAndExtract = async (url, options) => {
    try {
        const response = await fetch(url, options);
        
        if (!response.ok) {
            if (response.status === 404) {
                return null; // Document settings not found, return null
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error in fetchAndExtract:', error);
        throw error;
    }
};

const GetDocumentSettings = async (dto, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/Get`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify(dto)
    });
};

const CreateDocumentSettings = async (dto, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/Create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify(dto)
    });
};



const UpdateDocumentSettings = async (dto, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/Update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify(dto)
    });
};

const GetDocumentSettingsByCaseId = async (caseId, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/GetByCaseId/${caseId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        }
    });
};

const GetDocumentSettingsByAccountantId = async (accountantId, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/GetByAccountantId/${accountantId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        }
    });
};

const DeleteDocumentSettings = async (id, auth) => {
    return fetchAndExtract(`${API_BASE_URL}/DocumentSettings/Delete/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth}`
        }
    });
};

export {
    GetDocumentSettings,
    CreateDocumentSettings,
    UpdateDocumentSettings,
    GetDocumentSettingsByCaseId,
    GetDocumentSettingsByAccountantId,
    DeleteDocumentSettings
};
